import { render, staticRenderFns } from "./LoginWechat.vue?vue&type=template&id=164b0b53&scoped=true&"
import script from "./LoginWechat.vue?vue&type=script&lang=js&"
export * from "./LoginWechat.vue?vue&type=script&lang=js&"
import style0 from "./LoginWechat.vue?vue&type=style&index=0&id=164b0b53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b0b53",
  null
  
)

export default component.exports